// Only organizations from this country can opt back into the old reconciliation view
export const LEGACY_RECONCILIATION_VIEW_COUNTRY_ID = 'DK'
